









































































































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import EditLogistics from './logistics-edit.vue'
    import CreateLogistics from './logistics-create.vue'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'
    import Preview from 'vue-photo-preview'
    import moment from 'moment'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);

    class PageLogisticsRequest extends PageRequest {
        shipment: string;
        beginTime?: Date;
        endTime?: Date;
        beginrejectionTime?: Date;
        endrejectionTime?: Date;
        beginsignForTime?: Date;
        endsignForTime?: Date;
        selectShipmentEnd: string;
        phone: string;
        userCode: string;
        orderNumber: string;
        receiveStatus?: number;
        orderType?: number;
        isRelated?: boolean;
        isConfirm?: boolean;
        isNeedTakePicture?: boolean;
        constructor() {
            super();
            this.isRelated = null;
            this.orderType = null;
            this.receiveStatus = null;
        }
    }

    @Component({
        name:"logisticsList",
        components: { EditLogistics, CreateLogistics }
    })
    export default class Logistics extends AbpBase {
        shipmentReceiveStatus = Enums.getEnum(Enums.ShipmentReceiveStatus, true);
        whetherStatus = Enums.getEnum(Enums.WhetherStatus, true);
        pagerequest: PageLogisticsRequest = new PageLogisticsRequest();
        orderTypeStatus = Enums.getEnum(Enums.WarehouseOrderType, true);
        creationTime: Date[] = [moment(moment(new Date()).add(-15, 'days'), "YYYYMMDD").toDate(), new Date()];
        signForTime: Date[] = [];
        rejectionTime: Date[] = [];
        editModalShow: boolean = false;
        createModalShow: boolean = false;
        isDisplay: boolean = true;
        get list() {
            var a = this.hasPermission("OrderManage.MainLandOrderManage");
            var b = this.hasPermission("OrderManage.MainLandOrderManage.FreightCost");
            if (a == true && b == false) {
                this.isDisplay = false;
                return this.$store.state.backlogistics.list.filter(function (item) { return item.orderType == 1 });
            }
            else {
                return this.$store.state.backlogistics.list;
            }
           
        };
        get loading() {
            return this.$store.state.backlogistics.loading;
        }
        create() {
            this.createModalShow = true;
        }
        pageChange(page: number) {
            this.$store.commit('backlogistics/setCurrentPage', page);
            this.getpage();
        }
        pagesizeChange(pagesize: number) {
            this.$store.commit('backlogistics/setPageSize', pagesize);
            this.getpage();
        }

        async operationData(name: any, data: any) {
            if (name == '编辑') {
                this.$store.state.backlogistics.logisticsInfo = data;
                this.editModalShow = true;
            } else if (name == '删除') {
                await this.$store.dispatch({
                    type: 'backlogistics/delete',
                    data: { id: data.id }
                });
                this.getpage();
            }else if (name == '需要拍照') {
                await this.$store.dispatch({
                    type: 'backlogistics/isNeedTakePicture',
                    data: { id: data.id, isNeed: true }
                });
                this.getpage();
            }else if (name == '不需要拍照') {
                await this.$store.dispatch({
                    type: 'backlogistics/isNeedTakePicture',
                    data: { id: data.id, isNeed: false }
                });
                this.getpage();
            }
            var _this: any = this;
            _this.$previewRefresh();
        }

       async searchPage() {
            this.$store.state.backlogistics.currentPage=1;
            this.getpage();
        }

        async getpage() {

            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            if (this.signForTime.length > 0) {
                this.pagerequest.beginsignForTime = this.signForTime[0];
            }
            if (this.signForTime.length > 1) {
                this.pagerequest.endsignForTime = this.signForTime[1];
            }
            if (this.rejectionTime.length > 0) {
                this.pagerequest.beginrejectionTime = this.rejectionTime[0];
            }
            if (this.rejectionTime.length > 1) {
                this.pagerequest.endrejectionTime = this.rejectionTime[1];
            }
            if (this.creationTime.length > 0) {
                this.pagerequest.beginTime = this.creationTime[0];
            }
            if (this.creationTime.length > 1) {
                this.pagerequest.endTime = this.creationTime[1];
            }

            await this.$store.dispatch({
                type: 'backlogistics/getAll',
                data: this.pagerequest
            })
        }
        get pageSize() {
            return this.$store.state.backlogistics.pageSize;
        }
        get totalCount() {
            return this.$store.state.backlogistics.totalCount;
        }
        get currentPage() {
            return this.$store.state.backlogistics.currentPage;
        }
        columns = [{
            title: '快递单号',
            key: 'shipment',
            width: 150,
            fixed: 'left',
        }, {
            title: '订单编号',
            key: 'orderNumber',
            width: 150,
        }, {
            title: '仓库名称',
            key: 'warehouseName',
            width: 150,
        }, {
            title: '货架号',
            key: 'shelfNumber',
            width: 100,
        }, {
            title: '用户编号',
            key: 'userCode',
            width: 100,
            }, {
                title: '用户手机号',
                key: 'phone',
                width: 120,
            },{
            title: '订单用户编号',
            key: 'orderUserCode',
            width: 150,
            }, {
            title: '是否审核',
            key: 'isConfirm',
            width: 50,
                render: (h: any, params: any) => {
                    return h('span', params.row.isConfirm?"是":"否");
            }
            }, {
            title: '拍照',
            key: 'isNeedTakePicture',
            width: 50,
                render: (h: any, params: any) => {
                    return h('span', params.row.isNeedTakePicture?"是":"否");
            }
            }, {
                title: '入库人',
                width: 100,
                key: 'signUserName',
            },  {
                title: '用户上传图片',
                key: 'userUploadImageGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.userUploadImageGuid) {
                        var data = { imageGuid: params.row.userUploadImageGuid, url: null };
                        this.$store.commit('expressuserinfo/getImgUrl', data);
                        var url = data.url;;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: url,
                                preview: params.row.id+"^",
                                "preview-text": params.row.shipment
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            },  {
            title: '面单图片',
            key: 'imageGuid',
            width: 150,
            render: (h: any, params: any) => {
                if (params.row.imageGuid) {
                    var data = { imageGuid: params.row.imageGuid, url: null };
                    this.$store.commit('backlogistics/getImgUrl', data);
                    var url = data.url;
                    return h('img', {
                        style: {
                            width: "50px",
                            height: "50px",
                            verticalAlign: "middle"
                        },
                        attrs: {
                            src: url,
                            preview: params.row.id+"-",
                            "preview-text": params.row.imageGuid
                        }
                    });

                } else {
                    return h('span', "");
                }
            }
            }, {
                title: '物品图片',
                key: 'goodsImageGuid',
                width: 150,
                render: (h: any, params: any) => {
                    if (params.row.goodsImageGuid) {
                        var datas = { goodsImageGuid: params.row.goodsImageGuid, urls: null };
                        this.$store.commit('backlogistics/getGoodsImgUrl', datas);
                        var urls = datas.urls;
                        return h('img', {
                            style: {
                                width: "50px",
                                height: "50px",
                                verticalAlign: "middle"
                            },
                            attrs: {
                                src: urls,
                                preview: params.row.id+"_",
                                "preview-text": params.row.goodsImageGuid
                            }
                        });

                    } else {
                        return h('span', "");
                    }
                }
            }, {
            title: '状态',
            width: 90,
            key: 'receiveStatus',
            render: (h: any, params: any) => {
                return h('span', Enums.ShipmentReceiveStatus.filter(function (item) { return item.value == params.row.receiveStatus })[0].name);
            }
            }, {
            title: '创建时间',
            key: 'createTime',
            width: 100,
            render: (h: any, params: any) => {
                return h('span', DateUtils.formatLongDate(new Date(params.row.createTime)));
            }
        }, {
            title: '备注',
            width: 200,
            key: 'reMark',
        }, {
            title: '签收时间',
            key: 'signForTime',
            width: 100,
            render: (h: any, params: any) => {
                return h('span', params.row.signForTime ? DateUtils.formatLongDate(new Date(params.row.signForTime)) : '');
            }
        }, {
            title: '拒收时间',
            key: 'rejectionTime',
            width: 100,
            render: (h: any, params: any) => {
                return h('span', params.row.rejectionTime ? DateUtils.formatLongDate(new Date(params.row.rejectionTime)) : '');
            }
        }, {
            title: '操作',
            width: 100,
            fixed: 'right',
            key: 'id',
            render: (h: any, params: any) => {
                var _this = this;
                var menu = [];
                menu.push("编辑");
                if (params.row.isNeedTakePicture) {
                    menu.push("不需要拍照");
                }
                else{
                     menu.push("需要拍照");
                }
                if (!params.row.orderNumber) {
                    menu.push("删除");
                }
                return h('Dropdown', {
                    props: {
                        transfer: true,
                        trigger: 'click',
                    },
                    on: {
                        'on-click': (name) => {
                            _this.operationData(name, params.row);
                        }
                    }

                }, [
                    h('Button',
                        {
                            domProps: {
                                innerHTML: '<span>操作<i class="ivu-icon ivu-icon-ios-arrow-down"></i></span>',
                            },
                            props: {
                                type: 'primary',
                            }

                        }),
                    h('DropdownMenu', { slot: 'list' }, menu.map(item => {
                        return h('DropdownItem', { props: { name: item } }, item)
                    })
                    )]);
            }
        }]
        async created() {
            this.getpage();
        }
    }
